"use strict";
exports.__esModule = true;
exports.createBasket = exports.createBasketSession = void 0;
var model_1 = require("../../room/model");
var model_2 = require("../../extra/model");
// todo refactor rooms and hotelExtra in object and not array
exports.createBasketSession = function (payload) {
    if (payload === void 0) { payload = {}; }
    var rooms = payload.rooms && Object.keys(payload.rooms)
        ? Object.values(payload.rooms).map(function (value) { return model_1.createRoomBasketSession(value); })
        : [];
    var hotelExtras = payload.hotelExtras && Object.keys(payload.hotelExtras)
        ? Object.values(payload.hotelExtras).map(function (value) { return model_2.createExtraBasketSession(value); })
        : [];
    return {
        rooms: rooms,
        hotelExtras: hotelExtras,
        referenceRateIds: payload.referenceRateIds,
        isBookingRequest: payload.isBookingRequest,
        isMixedRate: payload.isMixedRate,
        hasOfferCode: payload.hasOfferCode
    };
};
exports.createBasket = function (payload, currency) {
    if (payload === void 0) { payload = {}; }
    var rooms = payload.rooms && Object.keys(payload.rooms)
        ? Object.values(payload.rooms).map(function (value) { return model_1.createRoomBasket(value); })
        : [];
    var hotelExtras = payload.hotelExtras && Object.keys(payload.hotelExtras)
        ? Object.values(payload.hotelExtras).map(function (value) { return model_2.createExtraBasket(value); })
        : [];
    return {
        id: Date.now().toString(10),
        rooms: rooms,
        hotelExtras: hotelExtras,
        price: payload.price,
        taxes: payload.taxes,
        isBookingRequest: payload.isBookingRequest,
        currency: currency
    };
};
//# sourceMappingURL=basket.js.map